import TransactionDetails from "../Components/TransactionDetails";

export default function Show() {
  return (
    <div>
      <TransactionDetails />
    </div>
  );
}
